import { Body1, Body1Strong, Caption1, Link } from '@fluentui/react-components';
import { AttachRegular, CallRegular, CheckmarkCircleFilled, MailRegular } from '@fluentui/react-icons';
import { CardNote } from './_shared.js';
import { useStyles } from './_styles.js';

const REQUESTED_INFORMATION = [
    'Versicherungsscheinnummer (VSNR)',
    'Wer meldet den Schaden? (z. B. Versicherungsnehmer)',
    'Schadendatum',
    'Schadenart',
    'Schadenursache',
    'Voraussichtliche Schadenhöhe',
    'Kurze Schilderung des Schadens',
    'E-Mail-Adresse & Kontaktinformationen für Rückfragen und die weitere Kommunikation',
];

type ContactDetailsProps = {
    phone: string;
    email: string;
    accent: string;
};

export function ContactDetails({ phone, email, accent }: ContactDetailsProps) {
    const styles = useStyles();

    return (
        <>
            <Body1 className={styles.lead}>Rufen Sie uns einfach an oder senden Sie uns eine E-Mail.</Body1>

            <div className={styles.contacts}>
                <Link className={styles.contact} href={`tel:${phone.replace(/[^+\d]/g, '')}`}>
                    <CallRegular className={styles.contactIcon} style={{ color: accent }} />

                    <span className={styles.contactText}>
                        <Caption1 className={styles.contactLabel}>Telefon</Caption1>
                        <Body1Strong className={styles.contactValue}>{phone}</Body1Strong>
                    </span>
                </Link>

                <Link className={styles.contact} href={`mailto:${email}`}>
                    <MailRegular className={styles.contactIcon} style={{ color: accent }} />

                    <span className={styles.contactText}>
                        <Caption1 className={styles.contactLabel}>E-Mail</Caption1>
                        <Body1Strong className={styles.contactValue}>{email}</Body1Strong>
                    </span>
                </Link>
            </div>

            <div className={styles.divider} />

            <Body1Strong className={styles.lead}>
                Damit wir Ihren Schaden schnell bearbeiten können, teilen Sie uns bitte möglichst folgende Informationen
                mit:
            </Body1Strong>

            <ul className={styles.checklist}>
                {REQUESTED_INFORMATION.map((information) => (
                    <li key={information} className={styles.checklistItem}>
                        <CheckmarkCircleFilled className={styles.checklistIcon} style={{ color: accent }} />
                        {information}
                    </li>
                ))}
            </ul>

            <CardNote icon={<AttachRegular />}>
                Falls bereits vorhanden, können Sie uns auch direkt Fotos, Rechnungen, Kostenvoranschläge oder andere
                relevante Unterlagen mitsenden.
            </CardNote>
        </>
    );
}
